<template>
  <v-navigation-drawer
    v-model="drawer"
    temporary
    right
    width="450"
    height="100%"
    app
  >
    <v-card
      v-if="drawer && designgroup"
      flat
      :loading="loading"
    >
      <v-card-title> Edit {{ designgroup.nameHierarchy }} Categories </v-card-title>
      <v-card-subtitle>
        <v-btn
          text
          :to="`/designgroups/${designgroup.id}`"
          target="_blank"
          color="info"
          class="px-0"
        >
          Edit Design Group
          <v-icon
            small
            class="ml-1"
          >
            open_in_new
          </v-icon>
        </v-btn>
      </v-card-subtitle>
      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
        >
          <v-row v-if="!loading">
            <v-col
              v-for="(item, i) in categories"
              :key="i"
              cols="12"
            >
              <v-checkbox
                v-model="selected"
                :label="item.name"
                :value="item.id"
                hide-details
                class="mt-0 pt-0"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
    <template #append>
      <div class="px-3 py-5">
        <v-btn
          color="primary"
          block
          large
          :loading="saving"
          @click="save"
        >
          Save
        </v-btn>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'EditDesignGroupCategoryEditList',

  components: {},

  data() {
    return {
      loading: false,
      valid: false,
      saving: false,
      drawer: false,
      selected: []
    };
  },

  computed: {
    ...mapGetters({
      designgroup: 'designgroups/designgroup',
      design_groups: 'lookup/design_groups',
      categories: 'lookup/categories'
    })
  },

  async mounted() {
    this.$bus.$off(this.$enums.EVENT_BUS_EVENTS.DESIGN_GROUP_CATEGORY_LIST_SHOW);
    this.$bus.$on(this.$enums.EVENT_BUS_EVENTS.DESIGN_GROUP_CATEGORY_LIST_SHOW, (data) => {
      this.loadData(data.designGroupId);
      this.drawer = true;
    });
  },

  methods: {
    async save() {
      if (!this.$refs.form.validate()) return;
      this.saving = true;
      this.$store
        .dispatch('designgroups/updateCategories', {
          designGroupId: this.designgroup.id,
          categoryIds: this.selected
        })
        .then(() => {
          this.drawer = false;
          this.$root.$snackbarSuccess('Design Group Categories saved');
          this.$emit('save');
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.saving = false;
        });
    },
    loadData(designGroupId) {
      this.loading = true;
      this.$store
        .dispatch('designgroups/get', designGroupId)
        .then(() => {
          this.selected = this.designgroup.categories.map((x) => x.category.id);
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
